<div class='admissions-commitments-page'>

	<toolbar icon='Admissions'>
		<button class="btn btn-light" (click)='admissionsService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i
				class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>
				
		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]="trimesterWindow"></trimester-droplist>
		</div>
		<!-- 
		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Commitments", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<admissions-commitments-views-part></admissions-commitments-views-part>
		</ng-template>

		<ng-template pageTab2>
			<admissions-commitments-tab-1-part></admissions-commitments-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<admissions-commitments-tab-2-part></admissions-commitments-tab-2-part>
		</ng-template>
	</page-tabs>

</div>